import Vue from 'vue'
import axios from 'axios'

export default {
    methods: {
        ApiErrorHandler: (context, status_code) => {
            switch (status_code) {
                case 401:
                    console.log('Session Expired!')
                    /*alert('Session Expired!');
                    context.$router.go('/login');*/
                    break;
            
                default:
                    break;
            }
        },

    }
}


// WEBPACK FOOTER //
// ./src/utils/mixin.js